import { Link } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { ShieldCheck } from "lucide-react";

const AuthShell = ({ children }) => (
  <div className="min-h-screen grid lg:grid-cols-2 bg-alabaster">
    <div className="hidden lg:flex flex-col justify-between bg-teal text-white p-12 grain">
      <Link to="/" className="font-display text-2xl inline-flex items-center gap-3" data-testid="auth-home-link"><img src="/images/logo.png" alt="" className="h-12 w-12 rounded-full" />Smileton Dental</Link>
      <div className="space-y-4 max-w-md">
        <ShieldCheck className="h-10 w-10 text-mint" />
        <h1 className="text-4xl font-semibold leading-tight">Clinic desk &amp; doctor portal</h1>
        <p className="text-white/80">Appointments, walk-ins, schedule and fees for Smileton Dental, Sainikpuri. Only staff approved by Dr. Vilayath Mahamadi get access.</p>
      </div>
      <p className="text-sm text-white/60">Patients don't need an account to book.</p>
    </div>
    <div className="flex flex-col items-center justify-center p-6 gap-6">
      <Link to="/" className="lg:hidden font-display text-2xl text-teal inline-flex items-center gap-2"><img src="/images/logo.png" alt="" className="h-10 w-10 rounded-full" />Smileton Dental</Link>
      {children}
    </div>
  </div>
);

export const SignInPage = () => (
  <AuthShell>
    <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
  </AuthShell>
);

export const SignUpPage = () => (
  <AuthShell>
    <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
  </AuthShell>
);
